<div id="infinite-scroll-global-container" #infiniteScrollGlobalContainer>
  <a class="skip-link" href="#main-content" (click)="skipToMain($event)">Skip to main content</a>
  @if (!isResourcePage) {
    <app-header [isResourcePage]="isResourcePage"></app-header>
  }
  @if (isResourcePage) {
    <app-resource-center-header></app-resource-center-header>
  }
  <main id="main-content" tabindex="-1"><router-outlet></router-outlet></main>

  <app-footer></app-footer>
</div>
